import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Label } from "components/bootstrap";
import ExpandableCellList from "components/common/ExpandableCellList";
const DEFAULT_COLLAPSED_COUNT = 1;
const HoverableLabel = styled(Label)(
  ({ theme }) => css`
    transition: background-color 0.1s ease-in-out;

    /* Override Label's flex label so the bare-string chip can be abbreviated with an ellipsis
       (overflow/text-overflow/white-space already come from Badge) instead of overflowing the cell. */
    .mantine-Badge-label {
      display: block;
    }

    /* Shrink as a flex item so the chip can truncate instead of leaking past the cell. */
    min-width: 0;
    max-width: 100%;

    /* Only clickable chips render as a <button> (via Label's own onClick prop) — restrict the
       hover/focus affordance to those so plain, non-clickable chips don't look interactive. */
    &:where(button):hover {
      background-color: ${theme.colors.gray[60]};
      cursor: pointer;
    }

    &:where(button):focus-visible {
      outline: 2px solid ${theme.colors.input.borderFocus};
      outline-offset: 2px;
      border-radius: 2px;
    }
  `
);
const ChipsCell = ({
  items,
  onItemClick = void 0,
  collapsedCount = DEFAULT_COLLAPSED_COUNT,
  truncate = true,
  renderItemContent = void 0,
  itemLabel,
  itemTitle = void 0
}) => {
  const { t } = useTranslation("common");
  const sorted = [...items != null ? items : []].sort();
  const renderChip = (item) => {
    const content = renderItemContent ? renderItemContent(item) : item;
    if (!onItemClick) {
      return /* @__PURE__ */ React.createElement(HoverableLabel, { bsStyle: "default", title: renderItemContent ? void 0 : item }, content);
    }
    const filterLabel = t("chips_cell.filter_by", { itemLabel, value: itemTitle ? itemTitle(item) : item });
    return /* @__PURE__ */ React.createElement(
      HoverableLabel,
      {
        bsStyle: "default",
        onClick: (e) => {
          e.stopPropagation();
          onItemClick(item);
        },
        "aria-label": filterLabel,
        title: filterLabel
      },
      content
    );
  };
  return /* @__PURE__ */ React.createElement(
    ExpandableCellList,
    {
      items: sorted,
      renderItem: renderChip,
      itemKey: (item) => item,
      collapsedCount: truncate ? collapsedCount : sorted.length,
      layout: "inline"
    }
  );
};
export default ChipsCell;
